import { getField, updateField } from "vuex-map-fields";
import API from "@/api";
import moment from "moment/moment";

const initialState = () => ({
  // vars state
  loadingTable: false,
  // paginacao
  totalItems: 0,
  totalPages: 0,
  itemsPerPage: 10,
  currentPage: 1,
  // filtros
  searchText: null,
  selectedGroup: null,
  groups: [],
  parametros: [],
  groupResponse: [],
});

export const state = initialState();

export const getters = {
  getField,
  formatDate: () => (date) => formatDate(date),
};

function mountSearchPayload(state) {
  const config = {
    params: new URLSearchParams(),
  };
  if (state.selectedGroup) config.params.append("idGroup", state.selectedGroup);
  if (state.searchText) {
    config.params.append("pkey", state.searchText);
    // || config.params.append('description', state.searchText)
  }

  config.params.append("size", state.itemsPerPage);
  config.params.append("page", state.currentPage - 1);
  return config;
}

export const actions = {
  async getGroups({ commit }) {
    const response = await API.axios.get("/param/api/v1/groups");
    if (response.status === 200) {
      commit("updateField", { path: "groups", value: response.data });
    }
    return response.status ? response.status : undefined;
  },
  async get({ state, commit }) {
    commit("updateField", { path: "loadingTable", value: true });
    commit("updateField", { path: "currentPage", value: 1 });
    commit("updateField", { path: "totalPages", value: 0 });

    const result = await API.axios.get(
      "/param/api/v1/parameters",
      mountSearchPayload(state)
    );
    if (!result || (result.status >= 400 && result.status < 600)) {
      commit("updateField", { path: "loadingTable", value: false });
      return !result.data.message ? undefined : result.data.message;
    } else if (!result.data.empty) {
      commit("updateField", { path: "currentPage", value: 1 });
      commit("updateField", {
        path: "totalPages",
        value: result.data.totalPages,
      });
    } else if (result.data.empty) {
      commit("updateField", { path: "currentPage", value: 0 });
      commit("updateField", { path: "totalPages", value: 0 });
    }
    commit("updateField", { path: "page", value: 0 });
    commit("updateField", {
      path: "totalItems",
      value: result.data.totalElements,
    });
    commit("updateField", { path: "parametros", value: result.data.content });
    commit("updateField", { path: "loadingTable", value: false });
    return state.parametros;
  },

  async getPage({ state, commit }, payload) {
    // type represents next or prev
    const { type } = payload;
    let page = 0;
    if (type === "next") {
      page = state.currentPage + 1;
    } else if (type === "prev") {
      page = state.currentPage - 1;
    } else if (type === "pageSelected") {
      if (state.currentPage > state.totalPages)
        commit("updateField", { path: "currentPage", value: state.totalPages });

      if (!state.currentPage || state.currentPage < 1)
        commit("updateField", { path: "currentPage", value: 1 });
      page = parseInt(state.currentPage);
    }
    commit("updateField", { path: "currentPage", value: page });

    commit("updateField", { path: "loadingTable", value: true });
    const result = await API.axios.get(
      "/param/api/v1/parameters",
      mountSearchPayload(state)
    );

    if (!result || (result.status >= 400 && result.status < 600)) {
      commit("updateField", { path: "currentPage", value: 1 });
      commit("updateField", { path: "totalPages", value: state.totalPages });
      commit("updateField", { path: "loadingTable", value: false });
      return !result ? undefined : result;
    } else if (!result.data.empty) {
      // update page offset
      commit("updateField", { path: "currentPage", value: page });
      commit("updateField", {
        path: "totalPages",
        value: result.data.totalPages,
      });
      commit("updateField", {
        path: "totalItems",
        value: result.data.totalElements,
      });
      // update table items
      commit("updateField", { path: "parametros", value: result.data.content });
    }
    commit("updateField", { path: "loadingTable", value: false });
  },
  // eslint-disable-next-line no-unused-vars
  async postGroups({ dispatch, state, commit }, payload) {
    const response = await API.axios.post("/param/api/v1/groups", payload);
    commit("updateField", { path: "groupResponse", value: response.data });
    return response;
  },
  // eslint-disable-next-line no-unused-vars
  async postParam({ dispatch, state }, payload) {
    const response = await API.axios.post("/param/api/v1/parameters", payload);
    return response;
  },
  // eslint-disable-next-line no-unused-vars
  async putParam({ dispatch, state }, payload) {
    const response = await API.axios.put(
      `/param/api/v1/parameters/${payload.id}`,
      payload
    );
    return response;
  },
  // eslint-disable-next-line no-unused-vars
  async deleteParam({ dispatch, state }, id) {
    const response = await API.axios.delete(`/param/api/v1/parameters/${id}`);
    return response;
  },

  resetState({ commit }) {
    commit("resetState");
  },
};

function formatDate(data) {
  return data == null ? "-" : moment(data).format("DD/MM/YYYY HH:mm");
}

export const mutations = {
  updateField,
  resetState(state) {
    Object.assign(state, initialState());
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
